__turbopack_context__.v({
  "button": "signin-module-scss-module__sZvggq__button",
  "guestCheckoutButton": "signin-module-scss-module__sZvggq__guestCheckoutButton",
  "guestCheckoutEnabled": "signin-module-scss-module__sZvggq__guestCheckoutEnabled",
  "hide": "signin-module-scss-module__sZvggq__hide",
  "hr": "signin-module-scss-module__sZvggq__hr",
  "leftCol": "signin-module-scss-module__sZvggq__leftCol",
  "rightCol": "signin-module-scss-module__sZvggq__rightCol",
  "signInStateActive": "signin-module-scss-module__sZvggq__signInStateActive",
  "signInStateNotActive": "signin-module-scss-module__sZvggq__signInStateNotActive",
  "signinContainer": "signin-module-scss-module__sZvggq__signinContainer",
});
